import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import WeightagesService from "../../../Services/weightagesService";
import DataParser from "../../../utlits/Dataparser";
import { message, Select } from "antd";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

message.config({ zIndex: 1000000001 });

const { Option } = Select;

const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const company_id = DataParser.CompanyId();

  const [attendance, setAttendance] = useState("");
  const [managerweightage, setManagerWeightage] = useState("");
  const [task, setTask] = useState("");
  const [taskprocess, setTaskProcess] = useState(null);
  const [attributeRows, setAttributeRows] = useState([{ attributetitle: "" }]);
  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await WeightagesService.detailWeightages(id);
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.data?.weightages) {
          const data = res.data.weightages;
          setAttendance(data.attendance || "");
          setManagerWeightage(data.managerweightage || "");
          setTask(data.task || "");
          setTaskProcess(data.taskprocess || null);
          setAttributeRows(data.attribute?.length ? data.attribute.map((a) => ({ attributetitle: a.attributetitle })) : [{ attributetitle: "" }]);
        }
      } catch (err) {
        console.error(err);
        message.error("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const handleAddRow = () => setAttributeRows([...attributeRows, { attributetitle: "" }]);

  const handleRemoveRow = (index) => {
    const rows = [...attributeRows];
    rows.splice(index, 1);
    setAttributeRows(rows);
  };

  const handleAttributeChange = (index, value) => {
    const rows = [...attributeRows];
    rows[index].attributetitle = value;
    setAttributeRows(rows);
  };

  const handleWeightageChange = (setter, field) => (e) => {
    let val = e.target.value.replace(/\D/, "");
    val = val ? Math.min(100, parseFloat(val)) : "";

    const a = field === "attendance" ? val : attendance || 0;
    const m = field === "managerweightage" ? val : managerweightage || 0;
    const t = field === "task" ? val : task || 0;

    if (parseFloat(a || 0) + parseFloat(m || 0) + parseFloat(t || 0) > 100) {
      message.warning("Total of Attendance, Manager, and Task cannot exceed 100");
      return;
    }
    setter(val);
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (!attendance) newErrors.attendance = "Attendance Weightage is required";
    if (!managerweightage) newErrors.managerweightage = "Manager Weightage is required";
    if (!task) newErrors.task = "Task Weightage is required";
    if (!taskprocess) newErrors.taskprocess = "Task Process is required";
    attributeRows.forEach((row, idx) => {
      if (!row.attributetitle.trim()) newErrors[`attribute-${idx}`] = "Attribute title is required";
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setIsSending(true);
    try {
      const res = await WeightagesService.updateWeightages(id, { attendance, managerweightage, task, taskprocess, attribute: attributeRows, company_id });
      if (res.data === "Un-Athunticated request") {
        message.error("Session expired! Please log in again.");
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
        return;
      }
      if (res.Good) {
        message.success("Performance weightage updated successfully!");
        navigate(`/${DataParser.CompanyIdentifierRole()}/performanceweightage`);
      } else {
        message.error("Could not update performance weightage. Try again!");
      }
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message || "An error occurred.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Edit Performance Weightage - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0 pt-3">
                    {loading ? (
                      <div className="w-100 p-2">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                          <Skeleton height={44} borderRadius={8} />
                          <Skeleton height={44} borderRadius={8} />
                          <Skeleton height={44} borderRadius={8} />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                          <Skeleton height={44} borderRadius={8} />
                          <Skeleton height={44} borderRadius={8} />
                          <Skeleton height={44} borderRadius={8} />
                        </div>
                        <Skeleton height={44} borderRadius={8} style={{ marginBottom: '16px' }} />
                        <Skeleton height={100} borderRadius={8} />
                      </div>
                    ) : (
                      <form onSubmit={onSubmitHandler}>

                        {/* Row 1: Attendance, Task, Task Process */}
                        <div className="row mb-4">
                          <div className="col-md-4 mb-3">
                            <div className="float-input-wrap">
                              <input
                                type="number"
                                placeholder=" "
                                value={attendance}
                                onChange={handleWeightageChange(setAttendance, "attendance")}
                                className={errors.attendance ? "is-invalid" : ""}
                                min="0" max="100"
                              />
                              <label>Attendance Weightage</label>
                            </div>
                            {errors.attendance && <small className="text-danger">{errors.attendance}</small>}
                          </div>

                          <div className="col-md-4 mb-3">
                            <div className="float-input-wrap">
                              <input
                                type="number"
                                placeholder=" "
                                value={task}
                                onChange={handleWeightageChange(setTask, "task")}
                                className={errors.task ? "is-invalid" : ""}
                                min="0" max="100"
                              />
                              <label>Task Weightage</label>
                            </div>
                            {errors.task && <small className="text-danger">{errors.task}</small>}
                          </div>

                          <div className="col-md-4 mb-3">
                            <div className={`float-select-wrap ${taskprocess ? "has-value" : ""}`}>
                              <label>Task Process</label>
                              <Select
                                placeholder=""
                                value={taskprocess || null}
                                onChange={(v) => { setTaskProcess(v); setErrors((prev) => ({ ...prev, taskprocess: "" })); }}
                              >
                                <Option value="manual">Manual</Option>
                                <Option value="automatic">Automatic</Option>
                              </Select>
                            </div>
                            {errors.taskprocess && <small className="text-danger">{errors.taskprocess}</small>}
                          </div>
                        </div>

                        {/* Manager Weightage */}
                        <div className="row mb-4">
                          <div className="col-md-4 mb-3">
                            <div className="float-input-wrap">
                              <input
                                type="number"
                                placeholder=" "
                                value={managerweightage}
                                onChange={handleWeightageChange(setManagerWeightage, "managerweightage")}
                                className={errors.managerweightage ? "is-invalid" : ""}
                                min="0" max="100"
                              />
                              <label>Manager Weightage</label>
                            </div>
                            {errors.managerweightage && <small className="text-danger">{errors.managerweightage}</small>}
                          </div>
                        </div>

                        {/* Attribute Rows */}
                        <div className="mb-4">
                          <p className="fw-semibold mb-3" style={{ fontSize: "14px", color: "#1D1D1D" }}>Attributes</p>
                          {attributeRows.map((row, idx) => (
                            <div key={idx} className="mb-3">
                              <div className="d-flex gap-2" style={{ alignItems: "stretch" }}>
                                <div className="float-input-wrap" style={{ flex: 1 }}>
                                  <input
                                    type="text"
                                    placeholder=" "
                                    value={row.attributetitle}
                                    onChange={(e) => handleAttributeChange(idx, e.target.value)}
                                    className={errors[`attribute-${idx}`] ? "is-invalid" : ""}
                                    style={{ height: "40px", padding: "8px 14px" }}
                                  />
                                  <label>Attribute Title</label>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{ padding: "0 16px", flexShrink: 0, marginBottom: "3px" }}
                                  onClick={handleAddRow}
                                >+</button>
                                {attributeRows.length > 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    style={{ padding: "0 16px", flexShrink: 0, marginBottom: "3px" }}
                                    onClick={() => handleRemoveRow(idx)}
                                  >-</button>
                                )}
                              </div>
                              {errors[`attribute-${idx}`] && (
                                <small className="text-danger">{errors[`attribute-${idx}`]}</small>
                              )}
                            </div>
                          ))}
                        </div>

                        <div className="d-flex justify-content-end mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isSending}
                            style={{ padding: "0 28px", height: "38px" }}
                          >
                            {isSending ? "Updating..." : "Update"}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
